import React from 'react';
import PropTypes from 'prop-types';

export const PluginListIcon = ({ small = false, ...rest }) => {
  if (small) {
    return (
      <svg
        width="24"
        height="31"
        viewBox="0 0 24 31"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        <path
          d="M0.5 7.5L0.5 1.5C0.5 1.22386 0.723858 1 1 1L23 1C23.2761 1 23.5 1.22386 23.5 1.5V7.5C23.5 7.77614 23.2761 8 23 8L1 8C0.723858 8 0.5 7.77614 0.5 7.5Z"
          fill="#F4F4F4"
          stroke="#AEAEAE"
        />
        <path
          d="M0.5 18.5L0.5 12.5C0.5 12.2239 0.723858 12 1 12L23 12C23.2761 12 23.5 12.2239 23.5 12.5V18.5C23.5 18.7761 23.2761 19 23 19H1C0.723858 19 0.5 18.7761 0.5 18.5Z"
          fill="#F4F4F4"
          stroke="#AEAEAE"
        />
        <path
          d="M0.5 29.5L0.5 23.5C0.5 23.2239 0.723858 23 1 23H23C23.2761 23 23.5 23.2239 23.5 23.5V29.5C23.5 29.7761 23.2761 30 23 30H1C0.723858 30 0.5 29.7761 0.5 29.5Z"
          fill="#F4F4F4"
          stroke="#AEAEAE"
        />
      </svg>
    );
  }

  return (
    <svg
      width="101"
      height="87"
      viewBox="0 0 101 87"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M1 0.5H96.5C98.433 0.5 100 2.067 100 4V21C100 22.933 98.433 24.5 96.5 24.5H1V0.5Z"
        fill="#F4F4F4"
        stroke="#AEAEAE"
      />
      <rect x="1" y="31.5" width="99" height="24" rx="3.5" fill="#F4F4F4" stroke="#AEAEAE" />
      <path
        d="M4.5 62.5H100V86.5H4.5C2.56701 86.5 1 84.933 1 83V66C1 64.067 2.567 62.5 4.5 62.5Z"
        fill="#F4F4F4"
        stroke="#AEAEAE"
      />
    </svg>
  );
};

PluginListIcon.propTypes = {
  small: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/vp-ui/svgs/PluginListIcon.jsx